import { render } from "./MWNewRegistration.vue?vue&type=template&id=d676535c"
import script from "./MWNewRegistration.vue?vue&type=script&lang=js"
export * from "./MWNewRegistration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__